export default "__VITE_ASSET__OrD27I0v__"